(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/order-tickets-gift.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/order-tickets-gift.js');
"use strict";

const {
  account_services: accountServices,
  dialogs
} = svs.tur.pay;
const {
  getConfirmPaymentOptions,
  getAccountBalanceParams,
  getLatestAccountBalance
} = svs.ticketsOrderHome.utils;
function ticketsPriceSum(tickets) {
  return tickets.reduce((sum, _ref) => {
    let {
      price,
      count
    } = _ref;
    return sum + price * count;
  }, 0);
}
const createMailBoxPlayerOrderGiftRequest = _ref2 => {
  let {
    tickets,
    personalGreeting,
    message,
    addressReferenceId
  } = _ref2;
  return {
    referenceId: svs.utils.svsuid(),
    personalGreeting,
    message,
    addressReferenceId,
    orderItems: tickets.map(function () {
      let ticket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        productCode: parseInt(ticket.id, 10),
        quantity: ticket.count
      };
    })
  };
};
const mailBoxPlayerOrderGift = async data => await svs.core.jupiter.callAsync({
  method: 'POST',
  path: '/ticket/1/mailbox/giftorder',
  data
});
const orderTicketsHomeGift = async _ref3 => {
  let {
    next,
    requestParams
  } = _ref3;
  svs.ui.loader.show();
  const orderSummary = "Ordered (GIFT) ".concat(requestParams.tickets.map(_ref4 => {
    let {
      id,
      name,
      count
    } = _ref4;
    return "".concat(count, " st ").concat(name, "(").concat(id, ")");
  }).join(','));
  try {
    const request = createMailBoxPlayerOrderGiftRequest(requestParams);
    const {
      response
    } = await svs.ticketsOrderHome.services.mailBoxPlayerOrderGift(request);
    svs.tur.pay.logger.info("".concat(orderSummary, " success"));
    next({
      response
    });
  } catch (e) {
    svs.tur.pay.logger.error("".concat(orderSummary, " failed: ").concat(e));
    next({
      error: e
    });
  }
  svs.ui.loader.hide();
};
function handleOrderTicketsGiftResult(_ref5) {
  let {
    next,
    error
  } = _ref5;
  if (error) {
    svs.ticketsOrderHome.utils.showErrorMessage(error, next);
    throw error;
  } else {
    next();
  }
}
const orderTicketsGift = _ref6 => {
  let {
    requestParams,
    onCancel,
    onDone
  } = _ref6;
  const {
    tickets,
    afterPay
  } = requestParams;
  if (!(tickets !== null && tickets !== void 0 && tickets.length)) {
    return;
  }
  const priceSum = ticketsPriceSum(tickets) + svs.ticketsOrderHome.utils.constants.SHIPPING_COST;
  const isPayAfterDepositEnabled = svs.core.detect.feature('ft-tickets-pay-after-deposit');
  const totalCost = svs.utils.format.CurrencyFromJupiterString(priceSum);
  const shouldResolveAfterPay = isPayAfterDepositEnabled && afterPay;
  let accountBalance;
  let response;
  let error;
  let latestAccountBalance;
  const calls = [{
    fn: accountServices.playerSuspension
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.ALL, accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    fn: accountServices.playerDepositLimits
  }, {
    in: () => getAccountBalanceParams({
      isPayAfterDepositEnabled,
      price: totalCost
    }),
    fn: accountServices.accountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, {
    in: () => getConfirmPaymentOptions({
      price: totalCost,
      accountBalance
    }),
    fn: shouldResolveAfterPay ? _ref7 => {
      let {
        next
      } = _ref7;
      return next();
    } : dialogs.confirmPayment
  }, {
    in: () => ({
      requestParams
    }),
    fn: orderTicketsHomeGift,
    out: args => ({
      response,
      error
    } = args)
  }, {
    in: () => ({
      response,
      error
    }),
    fn: handleOrderTicketsGiftResult
  }, {
    fn: getLatestAccountBalance,
    out: args => ({
      latestAccountBalance
    } = args)
  }, {
    in: () => ({
      price: totalCost,
      accountBalance: latestAccountBalance !== null && latestAccountBalance !== void 0 ? latestAccountBalance : accountBalance
    }),
    fn: shouldResolveAfterPay ? svs.ticketsOrderHome.components.afterPaymentDialog : _ref8 => {
      let {
        next
      } = _ref8;
      return next();
    }
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      response,
      error
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done,
    shouldDisplayGeneralError: false
  });
};
setGlobal('svs.ticketsOrderHome.services.mailBoxPlayerOrderGift', mailBoxPlayerOrderGift);
setGlobal('svs.ticketsOrderHome.services.orderTicketsGift', orderTicketsGift);

 })(window);